import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { Box, CircularProgress, Tab, Tabs, Typography, useMediaQuery } from '@mui/material';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import fetch from '../../../fetch';
import { fromUnitAmount } from '../../../utils/unitAmountHelper';
import NavDesktop from '../../Nav/NavDesktop';
import NavMobile from '../../Nav/NavMobile';
import StatsDesktop from './components/StatsDesktop';
import StatsMobile from './components/StatsMobile';
import Analytics from './Tabs/Analytics';
import Payment from './Tabs/Payment';
import Support from './Tabs/Support';
import Upgrade from './Tabs/Upgrade';
import styles from './profile.module.scss';
import theme from '../../../theme';

const mapStateToProps = (state) => {
    return {
        company: state.common.company
    };
};

const Profile = (props) => {
    const { t } = useTranslation();
    const allTabs = [t('Payment'), t('Analytics'), t('Support')];
    const [totalEarned, setTotalEarned] = useState(null);
    const [totalStreams, setTotalStreams] = useState(null);
    const [currency, setCurrency] = useState('eur');
    const [totalStorage, setTotalStorage] = useState(null);
    const [activeTab, setActiveTab] = useState(0);
    const [loading, setLoading] = useState(false);
    const isMobile = useMediaQuery(theme.breakpoints.down('mobile'));

    const handleChange = (event, newValue) => {
        setActiveTab(newValue);
    };

    useEffect(() => {
        const fetchEarnings = async () => {
            try {
                setLoading(true);
                const result = await fetch.StripeAccount.getEarnings(props.company._id);
                const earnings = result.earnings;
                let sum = 0;
                let count = 0;
                Object.entries(earnings).forEach(([key, value]) => {
                    const currencyKey = Object.keys(value)[0];
                    setCurrency(currencyKey);
                    const currencyData = value[currencyKey];

                    sum += fromUnitAmount(currencyData.total, currencyKey);
                    count += currencyData.count;
                });
                setTotalEarned(sum);
                setTotalStreams(count);

                const stats = await fetch.Company.GetCompanyStreamingStats(
                    process.env.REACT_APP_COMPANY_ID
                );
                setTotalStorage(stats.storage);
            } catch (error) {
                console.log('ERROR: ', error);
            } finally {
                setLoading(false);
            }
        };
        if (props.company) {
            fetchEarnings();
        }
    }, [props.company]);

    return (
        <Box>
            {isMobile && <NavMobile />}
            <Box className={styles.topContainer}>
                {!isMobile && <NavDesktop />}
                <Box className={styles.content}>
                    <Box>
                        <Typography
                            fontSize={isMobile ? '34px' : '42px'}
                            sx={{
                                lineHeight: 'normal',
                                letterSpacing: !isMobile ? '-0.84px' : '-0.68px'
                            }}>
                            {t('MyProfile')}
                        </Typography>
                        <Typography
                            fontSize={isMobile ? '28px' : '42px'}
                            sx={{
                                opacity: 0.6,
                                lineHeight: 'normal',
                                letterSpacing: !isMobile ? '-0.84px' : '-0.56px'
                            }}>
                            {props?.company?.name}
                        </Typography>
                    </Box>
                </Box>
                {loading || !props.company ? (
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            paddingY: '2rem'
                        }}>
                        <CircularProgress />
                    </Box>
                ) : (
                    <>
                        {isMobile ? (
                            <StatsMobile
                                currency={currency}
                                totalEarned={totalEarned}
                                totalStreams={totalStreams}
                                totalStorage={totalStorage}
                            />
                        ) : (
                            <StatsDesktop
                                currency={currency}
                                totalEarned={totalEarned}
                                totalStreams={totalStreams}
                                totalStorage={totalStorage}
                            />
                        )}
                    </>
                )}
            </Box>
            {isMobile && (
                <Box sx={{ marginTop: '1rem' }}>
                    <Tabs
                        sx={{
                            '& .MuiTabs-indicator': {
                                backgroundColor: 'black'
                            }
                        }}
                        value={activeTab}
                        onChange={handleChange}>
                        {allTabs.map((tab, index) => (
                            <Tab
                                sx={{
                                    width: '33.33vw',
                                    borderBottom: '1px solid rgba(0, 0, 0, 0.20)',
                                    color: 'rgba(0, 0, 0, 0.60) !important'
                                }}
                                key={index}
                                label={tab}
                            />
                        ))}
                    </Tabs>
                    <Box className={styles.main}>
                        {activeTab === 0 && <Payment />}
                        {activeTab === 1 && <Analytics />}
                        {/* {activeTab === 2 && <Upgrade />} */}
                        {activeTab === 2 && <Support />}
                    </Box>
                </Box>
            )}
            <Box className={styles.main}>
                {!isMobile && (
                    <>
                        <>
                            {activeTab === 0 && <Payment />}
                            {activeTab === 1 && <Analytics />}
                            {/* {activeTab === 2 && <Upgrade />} */}
                            {activeTab === 2 && <Support />}
                        </>
                        <Box className={styles.settings}>
                            <Typography sx={{ fontSize: '18px', lineHeight: 'normal' }}>
                                {t('Settings')}
                            </Typography>
                            <Box
                                sx={{ fontSize: '18px', lineHeight: 'normal' }}
                                onClick={() => setActiveTab(0)}>
                                {activeTab === 0 && <ArrowBackIosIcon />}
                                {t('Payment')}
                            </Box>
                            <Box
                                sx={{ fontSize: '18px', lineHeight: 'normal' }}
                                onClick={() => setActiveTab(1)}>
                                {' '}
                                {activeTab === 1 && <ArrowBackIosIcon />}
                                {t('Analytics')}
                            </Box>
                            {/* <Box
                                sx={{ fontSize: '18px', lineHeight: 'normal' }}
                                onClick={() => setActiveTab(2)}>
                                {' '}
                                {activeTab === 2 && <ArrowBackIosIcon />}
                                {t('Upgrade')}
                            </Box> */}
                            <Box
                                sx={{ fontSize: '18px', lineHeight: 'normal' }}
                                onClick={() => setActiveTab(2)}>
                                {' '}
                                {activeTab === 2 && <ArrowBackIosIcon />}
                                {t('Support')}
                            </Box>
                        </Box>
                    </>
                )}
            </Box>
        </Box>
    );
};

export default connect(mapStateToProps)(Profile);
